import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c18efa78"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ion-text-center",
  style: {"font-size":"10px","color":"#79dea3"}
}
const _hoisted_2 = {
  key: 0,
  class: "ion-margin-bottom"
}

import { computed, toRefs } from 'vue';
import { IonButton, IonCard, IonRow, IonCol, IonGrid } from '@ionic/vue';

import { IProgress } from '@/support/interfaces/ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListCard',
  props: {
    routerLink: null,
    title: null,
    subtitle: null,
    type: null,
    number: null,
    isCompleted: { type: Boolean },
    progress: null
  },
  emits: ["retry"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'retry'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  routerLink: string;
  title: string;
  subtitle: string;
  type?: string;
  number?: number;
  isCompleted?: boolean;
  progress?: IProgress;
}



const { routerLink, title, subtitle, number, progress } = toRefs(props);



const canRetry = computed(() => props.isCompleted ?? false);

const onRetry = () => {
  emit('retry');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.type)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_1, _toDisplayString(__props.type) + " " + _toDisplayString(_unref(number)), 1))
      : _createCommentVNode("", true),
    _createVNode(_unref(IonCard), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonGrid), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "ion-padding ion-text-center" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", null, _toDisplayString(_unref(title)), 1),
                    _createElementVNode("p", null, _toDisplayString(_unref(subtitle)), 1),
                    (_unref(progress))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(progress).count, (number) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: `progress-${number}`,
                              class: _normalizeClass(["progress-dot", { done: _unref(progress).done >= number }])
                            }, null, 2))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(canRetry))
                      ? (_openBlock(), _createBlock(_unref(IonButton), {
                          key: 1,
                          expand: "full",
                          onClick: onRetry
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Retry ")
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_unref(IonButton), {
                          key: 2,
                          "router-link": _unref(routerLink),
                          expand: "full"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Continue ")
                          ]),
                          _: 1
                        }, 8, ["router-link"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})